<template>
<v-dialog
    v-model="dialog"
    fullscreen
    v-if="note != null"
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Edit Note</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickSave"
                >
                    Save &amp; Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <p
                v-if="has_older && !show_older_versions"
                style="margin-top: 15px"
            >
                This note has been edited (i.e. has older versions).  To view <a v-on:click="onClickShowOlderVersions">click here.</a>
            </p>

            <div
                v-if="show_older_versions"
                style="margin-top: 15px"
            >
                <b>Older Version(s)</b>
                <div
                    v-for="(item, index) in older_versions"
                    :key="index"
                >
                    <v-text-field
                        label="Date"
                        disabled
                        readonly
                        :value="$rc.pretty(item.time, 'date_and_time')"
                    />

                    <v-text-field
                        label="By"
                        disabled
                        readonly
                        :value="item.by_employee_label"
                    />

                    <v-textarea
                        label="Note Body"
                        v-model="item.body"
                        rows="1"
                        auto-grow
                        autofocus
                        style="margin-top: 15px"
                        readonly
                        disabled
                    />

                    <m-edit-blobs
                        label="Attachments"
                        v-model="item.blob_ids"
                        :process_media="false"
                        :externally_visible="false"
                        empty_text="No attachments"
                        purpose="note-attachment"
                        read_only
                    />
                </div>
            </div>


            <div
                v-if="show_older_versions"
            >
                <v-divider
                    style="margin-top: 15px; margin-bottom: 15px"
                />
                <b>Edit Note</b>
            </div>

            <v-textarea
                label="Note Body"
                v-model="note.current.body"
                rows="1"
                auto-grow
                autofocus
                style="margin-top: 15px"
            />

            <m-edit-blobs
                label="Attachments"
                v-model="note.current.blob_ids"
                :process_media="false"
                :externally_visible="false"
                empty_text="No attachments"
                purpose="note-attachment"
            />

            <div
                style="margin-top: 15px; text-align: right"
            >

                <v-btn
                    v-on:click="onClickSave"
                    color="primary"
                >
                    Save &amp; Close
                </v-btn>
            </div>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,
            stored_message_id: null,
            conversation_id: null,
            note: null,
            show_older_versions: false,
        }
    },

    methods: {

        showCreateNoteDialog(conversation_id, endpoint)
        {
            this.conversation_id = conversation_id;
            this.endpoint = endpoint;
            this.show_older_versions = false;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/conversations/notes/create-empty-note/:conversation_id',
            
                'params' : {
                        'conversation_id': conversation_id,
                    },
            
                'on_success': (data) => {
                        this.stored_message_id = data.stored_message_id;
                        this.note = data.note;

                        this.dialog = true;
                        this.last_dialog_guard = this.$router.dialog_guard;
                        this.$router.dialog_guard = this.dialogGuard;
                    },
            
                'on_error': 'Unable to create empty note',
            });
        },

        showEditNoteDialog(stored_message_id)
        {
            this.show_older_versions = false;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/conversations/notes/edit/:stored_message_id',
            
                'params' : {
                        'stored_message_id': stored_message_id,
                    },
            
                'on_success': (data) => {
                        this.stored_message_id = data.stored_message_id;
                        this.conversation_id = data.conversation_id;
                        this.endpoint = data.endpoint;

                        this.note = data.note;

                        this.dialog = true;
                        this.last_dialog_guard = this.$router.dialog_guard;
                        this.$router.dialog_guard = this.dialogGuard;
                    },
            
                'on_error': 'Unable to create empty note',
            });
        },

        onClickShowOlderVersions()
        {
            this.show_older_versions = true;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },

        onClickSave()
        {
            let params = _.cloneDeep(this.note.current);
            params.stored_message_id = this.stored_message_id;
            params.conversation_id = this.conversation_id;
            params.endpoint = this.endpoint;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/conversations/notes',
            
                'params' : params,
            
                'on_success': (data) => {
                        this.closeDialog();
                    },
            
                'on_error': 'Unable to save note',
            });
        },

        onClickCancel()
        {
            this.closeDialog();
        },
    },

    computed: {
        has_older() {
            if ( this.note == null ) 
                return false;
            
            return this.note.versions.length > 1;
        },

        older_versions()
        {
            if ( this.note == null ) 
                return [];

            let ret = [];

            for ( let i = 0; i < this.note.versions.length-1; i++ )
            {
                ret.push(this.note.versions[i]);
            }

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>